import { Select } from 'antd';

const SelectBranch = ({onChange, branches }) => {
    
    return (
        <div className="w-75 m-auto flex-wrap">
            <label htmlFor="branchSelector" className="form-label">
                Sede:
            </label>
            <Select 
                id="branchSelector"
                className="w-100 mb-5"
                onChange={onChange}
            >
                <option value="" disabled>
                    Selecciona una sede
                </option>
                {branches.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                        {branch.name}
                    </option>
                ))}
            </Select>
        </div>
    )
}

export default SelectBranch;